var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel panel-default",attrs:{"id":"panel-fiche","role":"container"}},[_c('conteneur',{attrs:{"elements":_vm.fiche.data.elements}}),_vm._v(" "),_c('edit-element',{ref:"editTitle",on:{"elementUpdate":_vm.handleTitleUpdate}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c23fb5d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ficheEspace/edit/ficheEspaceContentEdit.vue
// module id = null
// module chunks = 